import axios from "axios";
import { Toast } from "vant";

const _axios = axios.create({
  baseURL: process.env.VUE_APP_NEW_API,
  timeout: 20000,
  withCredentials: true
});

// 全局拦截处理
_axios.interceptors.response.use(response => {
  if (
    !response.data.success &&
    response.data.code !== 20004 &&
    response.data.code !== 30012
  ) {
    Toast(response.data.message);
  }
  if (
    response.data.code === 20004 ||
    response.data.code === 70004 ||
    response.data.code === 70006
  ) {
    window.localStorage.removeItem("token");
  }
  return response;
});

export const helloHttp = (url, data, method = "post", headers) => {
  return new Promise(function(resolve, reject) {
    let d = {
      url,
      method
    };
    if (method.toLowerCase() === "get") {
      d.params = data;
    } else {
      d.data = data;
    }
    if (data instanceof FormData) {
      d.headers = {
        "Content-Type": "multipart/form-data"
      };
    }
    if (headers) {
      d.headers = headers;
    }
    _axios(d)
      .then(response => {
        console.log(response);
        console.log(response.data);
        response && resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
